import { UserAction, UserStateProps, Types } from "./User.schema";

export const userReducer = (
  state: UserStateProps,
  action: UserAction
): UserStateProps => {
  switch (action.type) {
    case Types.CleanLogin:
      return {
        document: "",
        password: "",
        hasStore: false,
        store: "",
        username: "",
      };
    case Types.SetLogin: {
      return {
        ...state,
        document: action.payload.document || "",
        username: action.payload.username,
        hasStore: action.payload?.hasStore,
      };
    }

    case Types.SetPropertie:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
